// Spinner.tsx
import React from 'react';
import './Spinner.css'; // Make sure to include CSS for visual styling

const Spinner: React.FC = () => (
  <div className="spinner-container">
    <div className="loading-spinner"></div>
  </div>
);

export default Spinner;
